module.exports = __webpack_public_path__ + "img/logo.d41d7073.jpg";